import { PaymentMethods } from './inner_layout/payment/PaymentMethods';
import { PurchaseHistory } from './inner_layout/purchase-history/PurchaseHistory';
import { Setting } from './inner_layout/settings/Setting';
import { Address } from './inner_layout/address/Address';
import { PassKeys } from './inner_layout/passkey/PassKeys';
import { FAQs } from './inner_layout/faqs/FAQs';

export {
  PaymentMethods,
  PurchaseHistory,
  Setting,
  Address,
  PassKeys,
  FAQs,
};
